/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whywedo_Passion2Inputs */

const ja_careers_whywedo_passion2 = /** @type {(inputs: Careers_Whywedo_Passion2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリエイティビティへの熱い想い`)
};

const en_careers_whywedo_passion2 = /** @type {(inputs: Careers_Whywedo_Passion2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creative passion!`)
};

/**
* | output |
* | --- |
* | "Creative passion!" |
*
* @param {Careers_Whywedo_Passion2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whywedo_passion2 = /** @type {((inputs?: Careers_Whywedo_Passion2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whywedo_Passion2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whywedo_passion2(inputs)
	return en_careers_whywedo_passion2(inputs)
});
export { careers_whywedo_passion2 as "careers_whyWeDo_passion" }